
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.062 12.27h.882l5.566 5.578-1.662 1.662-5.578-5.566v-.882l-.3-.312a7.219 7.219 0 01-4.72 1.751 7.25 7.25 0 117.251-7.25 7.219 7.219 0 01-1.75 4.718l.311.301zM2.231 7.25a5.013 5.013 0 005.02 5.02 5.013 5.013 0 005.02-5.02 5.013 5.013 0 00-5.02-5.019 5.013 5.013 0 00-5.02 5.02z","fill":"#000","fill-opacity":".54"}})])
          )
        }
      }
    